/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  products: [],
  limit: 20,
  keywordFilter: '',
  selectedProductId: null,
  allowEndTimeOverride: false
};

const getters = {
  products: state => state.products,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
  allowEndTimeOverride: state => state.allowEndTimeOverride,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    const type = payload.type ? `&type=${payload.type}` : '';
    let keyword = '';
    const orderBy = payload.orderBy ? `&orderBy=${payload.orderBy}` : '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/products/list?${type}${keyword}${limit}${orderBy}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchProducts({ commit }, payload) {
    const path = `${payload.role}s/${payload.roleId}`;
    const tenant = payload.role === 'landlord' ? payload.id : payload.roleId;

    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/partners/${tenant}/products/list/guest-parkings`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchTenantProducts({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let type = '';
    if (payload.type) {
      type = `&type=${payload.type}`;
    }
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let keyword = '';
    const tenant = payload.user.data.selectedRole.role === 'landlord' ? payload.id : payload.user.data.selectedRole.id;
    if (payload.keyword) {
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/partners/${tenant}/products/list?${type}${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchPermitProducts({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    const keyword = '';
    const tenant = payload.user.data.selectedRole.role === 'landlord' ? payload.id : payload.user.data.selectedRole.id;
    return Vue.http.get(`${getApiPath(payload.user)}/partners/${tenant}/products/list/permit-pack`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchTenantProductsFull({ commit }, payload) {
    const limit = 'limit=100';
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    const tenant = payload.user.data.selectedRole.role === 'landlord' ? payload.id : payload.user.data.selectedRole.id;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/partners/${tenant}/products?${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchReport({ commit }, payload) {
    let productId = '';
    let tenantId = '';
    if (payload.data.productId) {
      productId = `&productId=${encodeURIComponent(payload.data.productId)}`;
    }
    if (payload.data.tenantId) {
      tenantId = `&tenantId=${encodeURIComponent(payload.data.tenantId)}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/products/report?${productId}${tenantId}`, { data: payload.data });
  },
  setAllowEndTimeOverride({ commit }, payload) {
    commit(mTypes.SET_ALLOW_END_TIME_OVERRIDE, payload);
  }
};

const mutations = {
  [mTypes.DATA_FETCHED](state, products) {
    state.products = products.data;
  },
  [mTypes.EDIT_DATA](state, updatedProduct) {
    const index = state.products.items.findIndex(obj => obj.id === updatedProduct.id);
    if (index !== -1) {
      Vue.set(state.products.items, index, updatedProduct);
    } else {
      state.products.items.unshift(updatedProduct);
    }
  },
  [mTypes.CLEAR_STATE](state) {
    state.products = {};
  },
  [mTypes.REMOVE_DATA](state, productId) {
    const index = state.products.items.findIndex(obj => obj.id === productId);
    state.products.items.splice(index, 1);
    state.products.total -= 1;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
  [mTypes.SET_PRODUCT_ID](state, selectedProductId) {
    state.selectedProductId = selectedProductId;
  },
  [mTypes.SET_ALLOW_END_TIME_OVERRIDE](state, allowEndTimeOverride) {
    state.allowEndTimeOverride = allowEndTimeOverride;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/products.js